import { Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { CachedEndpointData, ResourceMatchingOptions } from '../types';
import { combinedThreadMatchFn } from './combined-resource-match-functions';

export const findCachedThreadInListThreads = (
  queries: CachedEndpointData<'ListThreads'>[],
  {
    matchFn,
    matchValues,
    matchStrategy,
  }: Pick<ResourceMatchingOptions<Thread>, 'matchValues' | 'matchFn' | 'matchStrategy'>
) => {
  for (const query of queries) {
    for (const page of query.pages) {
      for (const thread of page.threads) {
        const isMatch = combinedThreadMatchFn({ matchValues, matchFn, matchStrategy })(thread);
        if (isMatch) {
          return thread;
        }
      }
    }
  }
  return undefined;
};
